import { Component } from "react";

/**
 * Catches a render error so one broken page cannot unmount the whole app to a white screen (QA-33). It shows a plain
 * message and a way forward; the error itself is logged to the console for developers and never shown to the visitor.
 * `resetKey` (for example the current path) clears the error when the visitor navigates elsewhere.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, key: props.resetKey };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.key) return { failed: false, key: props.resetKey };
    return null;
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error("Render error caught by ErrorBoundary:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="max-w-[900px] mx-auto px-6 py-20" role="alert" data-testid="error-boundary">
        <h1 className="font-display text-3xl font-black tracking-tight mb-3">Something Went Wrong</h1>
        <p className="text-lg text-slate-700 mb-6">This page could not be shown. Nothing you entered was submitted. Try again, or go back to the home page.</p>
        <div className="flex gap-3 flex-wrap">
          <button type="button" className="btn-outline" onClick={() => window.location.reload()}>Reload This Page</button>
          <a href="/" className="btn-green">Go To The Home Page</a>
        </div>
      </div>
    );
  }
}
